// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const RecommendedTimeIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'recommended-time'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M7.5 1.5V5.5M15.5 1.5V5.5M20.5 7.5V5.5C20.5 4.39543 19.6046 3.5 18.5 3.5H4.5C3.39543 3.5 2.5 4.39543 2.5 5.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H8M2.5 9.5H7.5M16.5 10.5L15.2253 14.3753C15.1601 14.5737 15.0492 14.7539 14.9016 14.9016C14.7539 15.0492 14.5737 15.1601 14.3753 15.2253L10.5 16.5L14.3753 17.7747C14.5737 17.8399 14.7539 17.9508 14.9016 18.0984C15.0492 18.2461 15.1601 18.4263 15.2253 18.6247L16.5 22.5L17.7747 18.6247C17.8399 18.4263 17.9508 18.2461 18.0984 18.0984C18.2461 17.9508 18.4263 17.8399 18.6247 17.7747L22.5 16.5L18.6247 15.2253C18.4263 15.1601 18.2461 15.0492 18.0984 14.9016C17.9508 14.7539 17.8399 14.5737 17.7747 14.3753L16.5 10.5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
RecommendedTimeIcon.displayName = 'RecommendedTimeIcon'
export { RecommendedTimeIcon }
